<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.jira_settings.form.api_url')"
            :is-required="true"
            :error="errorsData.api_url"
            :hint="__('settings.jira_settings.form.api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.api_url"
                :placeholder="__('settings.jira_settings.form.api_url')"
                :is-valid="isFormFieldValid('api_url')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.jira_settings.form.username')"
            :is-required="true"
            :error="errorsData.username"
            :hint="__('settings.jira_settings.form.username_hint')"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="__('settings.jira_settings.form.username')"
                :is-valid="isFormFieldValid('username')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.jira_settings.form.password')"
            :is-required="jiraSettings === null"
            :error="errorsData.password"
            :hint="__('settings.jira_settings.form.password_hint')"
        >
            <DInput
                id="password"
                v-model="form.password"
                :placeholder="__('settings.jira_settings.form.password')"
                type="password"
                :is-valid="isFormFieldValid('password')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.jira_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.jira_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.jira_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-show="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'JiraSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        jiraSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_url: this.jiraSettings?.api_url ?? null,
                username: this.jiraSettings?.username ?? null,
                password: this.jiraSettings?.password ?? null
            }),
            connectionStatus: '',
            credentialsValid: false,
            connectionException: null,
            errorsData: this.errors
        }
    },
    watch: {
        form: {
            handler: function () {
                this.connectionStatus = ''
                this.credentialsValid = false
            },
            deep: true
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            window.axios.post(this.$route('settings.jira-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                    self.credentialsValid = true
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
